/**
 * 图表库初始化工具
 * 用于解决Shadow DOM冲突问题
 */

// 初始化图表配置
export const initCharts = () => {
  if (typeof window !== 'undefined') {
    // 设置G2Plot的渲染模式 - 使用canvas而不是svg
    window.g2plot_container_custom_render_mode = true;
    window.g2plot_container_renderer = 'canvas';
    
    // 设置G2的渲染模式
    window.G2 = window.G2 || {};
    window.G2.Global = window.G2.Global || {};
    window.G2.Global.renderer = 'canvas';
    window.G2.Global.disableShadow = true;
    
    // 设置其他相关库的渲染模式
    window.g2_renderer = 'canvas';
    window.g2_custom_render_mode = true;
    window.bizcharts_renderer = 'canvas';
    
    // 禁用Shadow DOM
    const originalAttachShadow = Element.prototype.attachShadow;
    if (originalAttachShadow) {
      // 重写attachShadow方法，防止多次调用
      Element.prototype.attachShadow = function(init) {
        try {
          // 尝试获取已有的shadow root
          const existingShadow = this.shadowRoot;
          if (existingShadow) {
            return existingShadow;
          }
          // 如果没有，则创建新的
          return originalAttachShadow.call(this, init);
        } catch (e) {
          console.warn('Shadow DOM attachment prevented:', e);
          // 返回一个模拟的shadowRoot对象
          const div = document.createElement('div');
          // 添加必要的方法，模拟shadowRoot
          div.appendChild = function(el) { return document.body.appendChild(el); };
          div.removeChild = function(el) { return document.body.removeChild(el); };
          div.querySelector = function(selector) { return document.querySelector(selector); };
          div.querySelectorAll = function(selector) { return document.querySelectorAll(selector); };
          return div;
        }
      };
    }
    
    // 更直接的方式修复registerPlugin问题
    const patchG2 = () => {
      // 监听G2对象的变化
      const observer = new MutationObserver(() => {
        try {
          // 检查G2是否已加载
          if (window.G2) {
            // 修补Chart类
            if (window.G2.Chart) {
              const originalRender = window.G2.Chart.prototype.render;
              window.G2.Chart.prototype.render = function() {
                try {
                  // 在渲染前确保_renderer存在
                  if (this._renderer && !this._renderer.registerPlugin) {
                    this._renderer.registerPlugin = function() { return this; };
                  }
                  return originalRender.apply(this, arguments);
                } catch (e) {
                  console.error('Chart render error:', e);
                  return this;
                }
              };
              
              // 修补_createCanvas方法
              const originalCreateCanvas = window.G2.Chart.prototype._createCanvas;
              window.G2.Chart.prototype._createCanvas = function() {
                try {
                  // 在创建canvas前确保_renderer存在
                  if (!this._renderer) {
                    this._renderer = {
                      registerPlugin: function() { return this; }
                    };
                  } else if (!this._renderer.registerPlugin) {
                    this._renderer.registerPlugin = function() { return this; };
                  }
                  return originalCreateCanvas.apply(this, arguments);
                } catch (e) {
                  console.error('Chart _createCanvas error:', e);
                  return this;
                }
              };
            }
            
            // 停止观察
            observer.disconnect();
          }
        } catch (e) {
          console.error('Error patching G2:', e);
        }
      });
      
      // 开始观察document变化
      observer.observe(document, { 
        childList: true, 
        subtree: true 
      });
      
      // 立即尝试修补
      if (window.G2 && window.G2.Chart) {
        try {
          const originalRender = window.G2.Chart.prototype.render;
          window.G2.Chart.prototype.render = function() {
            try {
              if (this._renderer && !this._renderer.registerPlugin) {
                this._renderer.registerPlugin = function() { return this; };
              }
              return originalRender.apply(this, arguments);
            } catch (e) {
              console.error('Chart render error:', e);
              return this;
            }
          };
        } catch (e) {
          console.error('Error immediate patching G2:', e);
        }
      }
    };
    
    // 立即执行修补
    patchG2();
    
    console.log('图表库初始化完成，已禁用Shadow DOM，修复registerPlugin问题');
  }
};

export default {
  initCharts
}; 